import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation } from 'react-router-dom'

import { Start } from '@/assets/images/common'
import { Logo } from '@/assets/images/logo'
import { cn } from '@/lib/utils'
import { RoutePath } from '@/routes'

import { Container, Flex } from '../common/Box'
import { SilkscreenText, Text } from '../common/Text'

const Banner: React.FC = () => {
  const { t } = useTranslation()
  const location = useLocation()

  const showSearch = useMemo(
    () => location.pathname === RoutePath.HOME,
    [location.pathname]
  )

  const renderSlogan = useCallback(() => {
    if (location.pathname === RoutePath.AIRDROP)
      return (
        <SilkscreenText className="text-white">
          {t('airdrop.slogan')}
        </SilkscreenText>
      )
    if (
      location.pathname === RoutePath.MINING_PLATFORM ||
      location.pathname === RoutePath.MINING_INFLUENCE
    )
      return (
        <SilkscreenText className="text-white">
          {t('mining.slogan')}
        </SilkscreenText>
      )
    if (location.pathname === RoutePath.DAO)
      return (
        <SilkscreenText className="leading-tight text-white xl:text-[40px]">
          {t('dao.slogan')}
        </SilkscreenText>
      )

    return (
      <>
        <Text className="font-Silkscreen text-white xl:whitespace-normal">
          {t('common.slogan')}
        </Text>
        <img
          src={Logo}
          className={cn(
            'size-10 xl:size-20',
            'xl:absolute xl:right-0 xl:top-1/2 xl:-translate-y-1/2 xl:translate-x-full'
          )}
          alt="terminus logo"
        />
      </>
    )
  }, [location.pathname, t])

  return (
    <Flex
      className={cn(
        'banner-mobile xl:banner relative',
        showSearch ? 'h-[280px] pb-6 pt-[50px]' : 'h-40 pt-[50px]',
        showSearch
          ? 'xl:h-[400px] xl:pb-0 xl:pt-0'
          : 'xl:h-[280px] xl:pt-[72px]'
      )}
    >
      <Container className="flex flex-col items-center justify-center py-0">
        <Flex
          className={cn(
            'relative items-center justify-center leading-normal',
            'text-xl xl:text-5xl',
            'text-center',
            'text-shadow'
          )}
        >
          {renderSlogan()}
        </Flex>
        {showSearch && (
          <NavLink
            to="/create"
            className={cn(
              'relative flex drop-shadow-[0_0_48px_rgba(26,22,62,0.6)] transition hover:drop-shadow-[0_0_48px_#FF8B79]',
              'mt-3 xl:mt-10'
            )}
          >
            <img src={Start} className="h-auto w-[150px] xl:w-[268px]" />
            <SilkscreenText
              className={cn(
                'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
                'text-nowrap pb-2 text-xs text-white xl:text-xl'
              )}
            >
              {t('common.startNewCoin')}
            </SilkscreenText>
          </NavLink>
        )}
      </Container>
    </Flex>
  )
}

export default Banner
